import PropTypes from 'prop-types';
import { ClickAwayListener, Tooltip, Typography } from '@material-ui/core';
import ArrowDownIcon from 'assets/icons/ArrowDownIcon';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from 'store';
import { useNavigate } from 'react-router-dom';
import { Images } from 'assets/images';
import { NAV_ITEMS_LOGINED } from 'utils/constant';
import {
  Avatar,
  MainContainer,
  MobileMenuItemContainer,
  MobileMenuItemsContainer,
  ToggleButton,
  TooltipContainer,
} from './styles';
import { navItems } from './data';

export const ProfileInfo = ({ className, isShowTooltip }) => {
  const { user } = useSelector(({ auth }) => auth);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleTooltip = () => {
    setOpen(!open);
  };

  const handleLogOut = () => {
    dispatch(authActions.logOut());
  };

  const handleNav = (path) => {
    path ? navigate(path) : handleLogOut();
  };

  const info = localStorage.getItem('credentials');

  // Todo change all
  return (
    <MainContainer className={className || ''}>
      <div className="right-side">
        <Avatar
          src="https://i.pinimg.com/originals/df/5f/5b/df5f5b1b174a2b4b6026cc6c8f9395c1.jpg"
          alt="Avatar"
        />

        <div className="left-side">
          <p className="fullname">{user?.data?.name}</p>
        </div>

        {isShowTooltip && (
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <Tooltip
              className="tooltip"
              PopperProps={{
                disablePortal: true,
              }}
              placement="top-end"
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title={
                <TooltipContainer>
                  <MobileMenuItemsContainer>
                    {info && (
                      <div>
                        {navItems.map((nav) => (
                          <MobileMenuItemContainer
                            key={nav.key}
                            onClick={() => handleNav(nav.path)}
                          >
                            <img src={nav.icon} alt="Loginedicon" />
                            <Typography variant="h6">{nav.title}</Typography>
                          </MobileMenuItemContainer>
                        ))}
                      </div>
                    )}

                    <div>
                      <div className="mob-desktop">
                        {NAV_ITEMS_LOGINED.map((i) => (
                          <MobileMenuItemContainer
                            key={i.key}
                            onClick={() => handleNav(i.path)}
                          >
                            <img src={i.icon} alt="icon" />
                            <Typography variant="h6">{i.title}</Typography>
                          </MobileMenuItemContainer>
                        ))}
                      </div>

                      <div className="logOut">
                        <MobileMenuItemContainer onClick={handleLogOut}>
                          <img src={Images.logOut} alt="logout" />

                          <Typography variant="h6">Log Out</Typography>
                        </MobileMenuItemContainer>
                      </div>
                    </div>
                  </MobileMenuItemsContainer>
                </TooltipContainer>
              }
            >
              <ToggleButton type="button" onClick={toggleTooltip}>
                <ArrowDownIcon />
              </ToggleButton>
            </Tooltip>
          </ClickAwayListener>
        )}
      </div>
    </MainContainer>
  );
};

ProfileInfo.defaultProps = {
  isShowTooltip: true,
};

ProfileInfo.propTypes = {
  isShowTooltip: PropTypes.bool,
};
